<template>
    <div class="topicValue">{{value}}</div>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: "topic-value",
    props: ['topic'],
    data() {
      return {
        value: '-'
      };
    },
    watch: {
      serialized: {
        immediate: true,
        handler() {
          this.value = this.mapping[this.topic];
        }
      }
    },
    computed: {
      ...mapGetters('mqtt', ['serialized', 'mapping'])
    }
  }
</script>

<style scoped>
    .topicValue {
        display: inline;
    }
</style>